import {TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class CustomTranslateLoader implements TranslateLoader {

  private delegate: TranslateLoader;

  constructor(http: HttpClient) {
    this.delegate = new TranslateHttpLoader(http, '/assets/i18n/Catalog');
  }

  getTranslation(lang: string): Observable<any> {

    if (!environment.production || lang === 'developer') {
      return this.delegate.getTranslation('');
    }

    if (lang === 'translator') {
      return of({});
    }

    return this.delegate.getTranslation('.' + lang).pipe(
      catchError(() => {
        return this.delegate.getTranslation('');
      })
    );
  }

}
